import React, {useState} from 'react';
import ReactSlider from 'react-slick';
import {FaTrophy, FaCheckCircle} from 'react-icons/fa';
import {useLang} from '../context/LanguageContext';
import SoccerBallNet from './SoccerBallNet';

const LastPredictionsSlider = ({ data }) => {
  // afisam doar predictiile castigate
  const wins = data.wins;
  const { t, getBetTranslation } = useLang()
  const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    afterChange: (index) => setActiveIndex(index),
  };

  return (
    <div className="mx-auto my-4 w-full max-w-[95vw] md:max-w-[800px] overflow-hidden">
      <h2 className="text-xl font-bold text-center mb-4 text-white">
        {t('txt.lastPredictions')}
      </h2>

      <ReactSlider {...settings}>
        {wins.map((item, index) => {
          const translatedMarketName = getBetTranslation(item.marketName);
          const translatedMarket = getBetTranslation(item.market);
          const isActive = index === activeIndex;

          return (
          <div key={item.id} className="p-2">
            <div className="rounded-xl overflow-hidden shadow-lg border border-white/10 bg-gradient-to-br from-emerald-500 to-emerald-800">
              <div className="p-4 flex items-center gap-3">
                <div className="shrink-0 w-14 h-14 rounded-full overflow-hidden flex items-center justify-center bg-yellow-400/20">
                  {isActive ? (
                    <SoccerBallNet isWin={true}/>
                  ) : (
                    <FaTrophy className="text-yellow-300 text-xl" />
                  )}
                </div>
                <div className="min-w-0 flex-1">
                  <span className="inline-block text-[10px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wide bg-yellow-400 text-emerald-900">
                    {t('txt.winningTicketsBadge')}
                  </span>
                  <p className="text-white text-sm font-bold mt-1 truncate">
                    {item.team1} vs {item.team2}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-white/70 truncate">
                    {item.flag && (
                      <img src={item.flag} alt="Flag" className="w-4 h-4 rounded-full shrink-0" />
                    )}
                    <span className="truncate">{item.countryName}</span>
                  </div>
                </div>
              </div>

              <div className="bg-black/20 px-4 py-3 flex items-center justify-between gap-3">
                <div className="min-w-0 text-white text-xs">
                  <p className="text-white/80">{item.day} · {item.hour}</p>
                  <p className="mt-0.5 truncate">
                    {translatedMarketName} ({translatedMarket})
                  </p>
                </div>
                <FaCheckCircle className="shrink-0 text-emerald-300 text-xl" />
              </div>
            </div>
          </div>
        )})}
      </ReactSlider>
    </div>
  );
};

export default LastPredictionsSlider;
